import Address from './Address';

export default class ContactInfo {
    public address: Address = new Address();
    public email: string;
    public mobileNumber: string;
}
